// Module
var code = "<div> <iris ng-repeat=\"iris in irisOrder\" irises-score=\"irisesScore\" iris=\"irises[iris.index]\" position=\"iris.position\" img-click=\"imgClick(iris.index)\" show-matching-details=\"showMatchingDetails\" no-hover=\"noHover\"></iris> </div> ";
// Exports
module.exports = code;